import { Box } from "@chakra-ui/react";
import React from "react";
import { IWizardDefinition } from "./types";

export interface IWizardProps<
  WizardData extends Record<ScreenIds, any>,
  ScreenIds extends string
> {
  definition: IWizardDefinition<WizardData, ScreenIds>;
  wizardData: WizardData;
}

const Wizard = <
  WizardData extends Record<ScreenIds, any>,
  ScreenIds extends string
>({
  definition,
  wizardData,
}: IWizardProps<WizardData, ScreenIds>) => {
  const screenIds = Object.keys(definition.screens) as unknown as ScreenIds[];
  const [screenId, setScreenId] = React.useState(screenIds[0]);
  const [history, setHistory] = React.useState([screenIds[0]]);
  const [data, setData] = React.useState(wizardData);

  const containerRef = React.useRef<HTMLDivElement>(null);

  const currentScreen = definition.screens[screenId];
  if (!currentScreen) {
    throw new Error(`No screen found with id ${screenId}`);
  }
  const Screen = currentScreen.component;

  // Jump to top of screen on transition
  React.useEffect(() => {
    containerRef.current?.scrollIntoView();
  }, [Screen]);

  return (
    <Box ref={containerRef} w="100%">
      <Screen
        wizardData={data}
        initialValues={data[screenId]}
        onBack={(values) => {
          setData({ ...data, [screenId]: values });

          const previousIndex = history.findIndex((i) => i === screenId) - 1;
          setHistory(history.slice(0, -1));
          setScreenId(history[previousIndex]);
        }}
        onSubmit={(values, nextScreenId) => {
          setData({ ...data, [screenId]: values });
          setHistory([...history, nextScreenId]);
          setScreenId(nextScreenId);
        }}
      />
    </Box>
  );
};

export default Wizard;
